import { render, staticRenderFns } from "./bjgwyf.vue?vue&type=template&id=44809b4a&scoped=true&"
import script from "./bjgwyf.vue?vue&type=script&lang=js&"
export * from "./bjgwyf.vue?vue&type=script&lang=js&"
import style0 from "./bjgwyf.vue?vue&type=style&index=0&id=44809b4a&lang=less&scoped=true&"
import style1 from "./bjgwyf.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44809b4a",
  null
  
)

export default component.exports